"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_bootstrap_table_next_1 = __importDefault(require("react-bootstrap-table-next"));
const tarif_api_1 = require("../../../../utils/api/tarif/tarif.api");
const CustomPagination_1 = require("../../../Common/CustomPagination");
const fa_1 = require("react-icons/fa");
const react_hot_toast_1 = __importDefault(require("react-hot-toast"));
const UseAddTarifPeage_1 = require("../requestForm/UseAddTarifPeage");
const TableSkeleton_1 = __importDefault(require("../../AdminShared/TableSkeleton"));
const EmptyAlert_1 = __importDefault(require("../../../Shared/Alerts/EmptyAlert"));
const EditableCell = ({ value, onSave, }) => {
    const [isEditing, setIsEditing] = (0, react_1.useState)(false);
    const [tempValue, setTempValue] = (0, react_1.useState)(value);
    const handleBlur = () => {
        setIsEditing(false);
        if (tempValue !== value)
            onSave(tempValue);
    };
    return isEditing ? (react_1.default.createElement("input", { type: "text", autoFocus: true, className: "form-control form-control-sm", value: tempValue, onChange: (e) => setTempValue(e.target.value), onBlur: handleBlur, onKeyDown: (e) => {
            if (e.key === "Enter")
                handleBlur();
        } })) : (react_1.default.createElement("div", { onDoubleClick: () => setIsEditing(true) }, value));
};
const DeleteTarifButton = ({ id }) => {
    const onDelete = (0, UseAddTarifPeage_1.UseDeleteTarifPeage)(id);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("button", { className: "btn with-tooltip btn-action-icon-delete", style: { color: "#E53E3E" }, "data-tooltip-content": "Supprimer", onClick: () => onDelete() },
            react_1.default.createElement(fa_1.FaTrash, null))));
};
const TarifsAdminTable = ({ search }) => {
    const [page, setPage] = (0, react_1.useState)(1);
    const [perPage, setPerPage] = (0, react_1.useState)(10);
    const { data = { data: [], count: 0 }, isLoading } = (0, tarif_api_1.useGetTarifsTrajetsQuery)({});
    const [updateTarif] = (0, tarif_api_1.useAddOrUpdateTarifMutation)();
    const [addTarif] = (0, tarif_api_1.useAddTarifMutation)();
    const formattedData = (0, react_1.useMemo)(() => {
        return data.data.map((item) => ({
            id: item.id,
            toll_point_name: item.toll_point_name,
            moto: item.moto,
            vehicule_leger: item.vehicule_leger,
            minibus_camionette: item["minibus_/_camionette"],
            poids_lourd_bus: item["poids_lourds_/_bus"],
        }));
    }, [data]);
    const filteredData = (0, react_1.useMemo)(() => {
        return formattedData.filter((item) => {
            var _a;
            const matchSearch = (_a = item.toll_point_name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(search.toLowerCase());
            return matchSearch;
        });
    }, [formattedData, search]);
    const paginatedData = (0, react_1.useMemo)(() => {
        return filteredData.slice((page - 1) * perPage, page * perPage);
    }, [filteredData, page, perPage]);
    const getTariffFormatter = (fieldKey) => (cell, row) => {
        const cellData = row[fieldKey];
        const handleSave = (newPrice) => __awaiter(void 0, void 0, void 0, function* () {
            if (isNaN(Number(newPrice)) || Number(newPrice) < 0) {
                react_hot_toast_1.default.error("Prix invalide !");
                return;
            }
            const payload = {
                price: Number(newPrice),
                vehicule_type_id: cellData.vehicule_type_id,
                toll_point_id: cellData.toll_point_id,
            };
            try {
                if (cellData.id) {
                    const res = yield updateTarif({
                        id: cellData.id,
                        data: payload,
                    }).unwrap();
                    react_hot_toast_1.default.success(res.message);
                }
                else {
                    console.log("ici");
                    const res = yield addTarif({
                        pricings: [payload],
                    }).unwrap();
                    react_hot_toast_1.default.success(res.message);
                }
            }
            catch (err) {
                react_hot_toast_1.default.error("Erreur lors de la mise à jour");
                console.error(err);
            }
        });
        return (react_1.default.createElement("div", { className: "tariff-cell d-flex align-items-center justify-content-between gap-2" },
            react_1.default.createElement(EditableCell, { value: cellData.price, onSave: handleSave }),
            (cellData === null || cellData === void 0 ? void 0 : cellData.id) && react_1.default.createElement(DeleteTarifButton, { id: cellData === null || cellData === void 0 ? void 0 : cellData.id })));
    };
    // const actionFormatter = (cell: string, row: RowType) => (
    //     <div className="table-actions-btn-container-commandes d-flex justify-content-start gap-3">
    //        <DeleteTarifButton id={row?.id} />
    //     </div>
    // );
    const columns = [
        {
            dataField: "toll_point_name",
            text: "Poste de PÉAGE",
            headerStyle: { width: "300px", whiteSpace: "normal" },
        },
        {
            dataField: "moto",
            text: "MOTO",
            formatter: getTariffFormatter("moto"),
            headerStyle: { width: "150px" },
        },
        {
            dataField: "vehicule_leger",
            text: "VÉHICULE LÉGER",
            formatter: getTariffFormatter("vehicule_leger"),
            headerStyle: { width: "180px" },
        },
        {
            dataField: "minibus_camionette",
            text: "MINIBUS / CAMIONNETTE",
            formatter: getTariffFormatter("minibus_camionette"),
            headerStyle: { width: "220px" },
        },
        {
            dataField: "poids_lourd_bus",
            text: "POIDS LOURDS / BUS",
            formatter: getTariffFormatter("poids_lourd_bus"),
            headerStyle: { width: "200px" },
        },
        // {
        //     dataField: "id",
        //     text: "Actions",
        //     formatter: actionFormatter,
        //     headerStyle: { width: "100px" },
        // },
    ];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !!isLoading && react_1.default.createElement(TableSkeleton_1.default, { headers: columns }),
        !isLoading && (react_1.default.createElement("div", { className: "col-lg-12" },
            react_1.default.createElement("div", { className: "admin-table" },
                react_1.default.createElement(react_bootstrap_table_next_1.default, { keyField: "id", data: paginatedData, columns: columns, condensed: true, hover: true, wrapperClasses: "table-responsive admin-table", noDataIndication: () => (react_1.default.createElement(EmptyAlert_1.default, { textualContent: "Aucune donn\u00E9es trouv\u00E9es" })) }),
                react_1.default.createElement("div", { className: "custom-pagination-container" },
                    react_1.default.createElement(CustomPagination_1.CustomPagination, { nbPages: filteredData.length, page: page, onChange: (newPage, newPerPage) => {
                            setPage(newPage);
                            setPerPage(newPerPage);
                        }, perPage: perPage })))))));
};
exports.default = TarifsAdminTable;
